export default "__VITE_ASSET__$dyDl0NY__"